<template>
  <div class="animated fadeIn">
 <form @submit.prevent="submit">
    <b-row>
      <b-col sm="12">
      <b-form-group label="Para:">
      <multiselect 
        v-model="$v.formData.mailvalues.$model"
        :state="$v.formData.mailvalues.$dirty ? !$v.formData.mailvalues.$error : null"
        :options="optionsMailer"
        :multiple="true"
        :taggable="true"
        @tag="addMail"
        placeholder="Seleccione Correos"  >
        </multiselect>
        <small>Para agregar un nuevo correo escribalo y presione enter</small>
      </b-form-group>
     <b-form-group label="Cc:">
      <multiselect 
        v-model="formData.mailccvalues"
        :options="optionsccMailer"
        :multiple="true"
        :taggable="true"
        @tag="addccMail"
        placeholder="Seleccione Correos"  >
        </multiselect>
        <small>Para agregar un nuevo correo escribalo y presione enter</small>
      </b-form-group>
      <b-form-group label="Bcc:">
      <multiselect 
        v-model="formData.mailbccvalues"
        :options="optionsbccMailer"
        :multiple="true"
        :taggable="true"
        @tag="addbccMail"
        placeholder="Seleccione Correos"  >
        </multiselect>
        <small>Para agregar un nuevo correo escribalo y presione enter</small>
      </b-form-group>
        <b-form-group label="Asunto:">
            <b-form-input
            type="text"
            :state="$v.formData.subject.$dirty ? !$v.formData.subject.$error : null"
            v-model="$v.formData.subject.$model"
            placeholder="">
            </b-form-input>
        </b-form-group>
      <b-form-group>
          <label for="textarea-auto-height">Mensaje:</label>
          <b-form-textarea
            id="textarea"
            v-model="formData.mensaje"
            placeholder=""
            rows="3"
            max-rows="6">
          </b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
     <b-row>
    <b-col cols="12" class="text-left">
      <b-button type="submit" :disabled="disableButton" variant="primary" > {{textButton}}</b-button>
    </b-col>
  </b-row>
  </form>
  </div>
</template>

<script>
import Vue from 'vue'
 import {required, numeric, minLength, between} from 'vuelidate/lib/validators'
 import Multiselect from 'vue-multiselect'
 import VueNotifications from 'vue-notifications'
 import miniToastr from 'mini-toastr'

  const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

Vue.use(VueNotifications);
Vue.use(miniToastr);

    export default {
      name: "FormEmail",
        components: {
        Multiselect,

    },
      props: [
    "objReportQc",
   ],
      data () { 
        return {
          //DirLaravel:"http://192.168.0.13/packingonline/public/",
          DirLaravel:"https://qc.packapp.cl/",
          disableButton:false,
          textButton:"Enviar",
          image:'' ,
          optionsMailer: [],
          optionsccMailer: [],
          optionsbccMailer: [],
          formData: {
            mailvalues: [],
            mailccvalues: [],
            mailbccvalues: [],
            subject:"",
            mensaje:""
          }
        }
      },
      computed: {

    },
        validations: {
          formData: {
            mailvalues: {required},
            subject:{required},
          }
    },
      mounted() {
        var porciones = localStorage.getItem('img').split('/');

        this.image =  porciones[2];
        this.formData.subject = `${this.objReportQc.lot.origin} inspección de ${this.objReportQc.inspection_type_name}: G${this.objReportQc.lot.waybill} - Variedad ${this.objReportQc.lot.variety}`;
        this.formData.mensaje = `Estimado Productor ${this.objReportQc.lot.origin}, Le hacemos llegar mediante este medio, el resultado de inspeccion de calidad de la guia de despacho ${this.objReportQc.lot.waybill}, variedad ${this.objReportQc.lot.variety}`;
         this.getEmails();
      },
      methods: {
       submit() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          
            miniToastr.info("Faltan llenar datos en el formulario", "");

        } else {


        this.disableButton=true;
        this.textButton ="Enviando ...";

      let  params = {
                    id: this.objReportQc.inspection,
                    correos: this.formData.mailvalues,
                    correoscc: this.formData.mailccvalues,
                    correosbcc: this.formData.mailbccvalues,
                    asunto: this.formData.subject,
                    mensaje: this.formData.mensaje,
                    client: this.$store.getters.user.ID_CLIENTE,
                    img: this.image
                }

            this.$axios.post(''+this.DirLaravel+'controlcalidad/sendEvaluationEmail',params )
              .then(res => {

                this.disableButton=false;
                this.textButton ="Enviar";

                miniToastr.success("Correo enviado con exito", "");

              /*   this.disableButton=false;
                this.textButton ="Enviar";

                if(res.success==true){

                   miniToastr.success("Correo enviado con exito", "");

                }else{

                  miniToastr.error("Problemas al enviar correo", "");

                   this.formData.mailvalues=null;
                   this.formData.subject="";
                   this.formData.mensaje="";
        

                } */

              })
            .catch(function (error) {
            console.log(error.response);
              miniToastr.error("Problemas al enviar correo", "");
              this.disableButton=false;
              this.textButton ="Enviar";
                });
        }
      },
       addMail (newMail) {

          var regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

           if (regex.test(newMail)){
            this.formData.mailvalues.push(newMail);
            } else {
             miniToastr.error("Correo invalido", "");
            }
          
        },
         addccMail (newMail) {
            var regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

           if (regex.test(newMail)){
            this.formData.mailccvalues.push(newMail);
            } else {
             miniToastr.error("Correo invalido", "");
            }
          
        },
         addbccMail (newMail) {

            var regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

           if (regex.test(newMail)){
           this.formData.mailbccvalues.push(newMail);
            } else {
             miniToastr.error("Correo invalido", "");
            }
          
        },
        getEmails() {
            this.$axios.get ('/reports/qc_emails/'+this.objReportQc.lot.id)
                .then(res => {

                  this.optionsMailer = res.data.emails[0].to;
                  this.optionsccMailer = res.data.emails[0].cc;
                  this.optionsbccMailer = res.data.emails[0].bcc;

                  this.formData.mailvalues = res.data.emails[0].to;
                  this.formData.mailccvalues = res.data.emails[0].cc;
                  this.formData.mailbccvalues = res.data.emails[0].bcc;

                })
              .catch(error => {
                  console.log(error.response)
                });
        },
      },
    };
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
